export enum QuickActionType {
  CANCEL_AN_ORDER = "CANCEL_AN_ORDER",
  REPORT_DAMAGED_OR_MISSING_ITEMS = "REPORT_DAMAGED_OR_MISSING_ITEMS",
  RETURN_ITEMS = "RETURN_ITEMS",
  CONTACT_A_BRAND = "CONTACT_A_BRAND",
  TRACK_AN_ORDER = "TRACK_AN_ORDER",
  REQUEST_COMMISSION_CHANGE = "REQUEST_COMMISSION_CHANGE",
  EDIT_ITEM_AVAILABILITY = "EDIT_ITEM_AVAILABILITY",
  ACCEPT_AN_ORDER = "ACCEPT_AN_ORDER",
}

export type QuickAction = {
  id: keyof typeof QuickActionType;
  label: string;
};

export type QuickActions = Partial<Record<QuickActionType, QuickAction>>;
